// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__IDB99","list":"styles_list__2nRP-"};